import React from 'react';
import { BookOpen, Target, MessageSquare, Users, Bot, Calendar, FileText, Gift } from 'lucide-react';
import { motion } from 'framer-motion';
export function ProductPresentation() {
  return <section className="py-20 bg-brand-lighter px-6 lg:px-8" data-id="element-255">
      <div className="max-w-5xl mx-auto text-center" data-id="element-256">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-257">
          <h2 className="text-3xl md:text-5xl font-extrabold text-brand-navy mb-6" data-id="element-258">
            El arsenal completo para tu despegue
          </h2>
          <p className="text-xl text-brand-navy/70 mb-12 max-w-2xl mx-auto" data-id="element-259">
            Todo lo que necesitas para estructurar tu negocio inmobiliario desde
            el día uno, sin inventar la rueda.
          </p>
        </motion.div>

        <div className="flex flex-col md:flex-row justify-center items-center gap-8 mb-16" data-id="element-260">
          <div className="bg-white rounded-2xl p-8 shadow-soft border border-brand-light w-full md:w-64" data-id="element-261">
            <BookOpen className="w-12 h-12 text-brand-accent mx-auto mb-4" data-id="element-262" />
            <div className="text-4xl font-extrabold text-brand-navy mb-2" data-id="element-263">
              6
            </div>
            <div className="text-brand-navy/70 font-medium" data-id="element-264">
              Módulos de Sistema
            </div>
          </div>
          <div className="text-brand-accent font-bold text-3xl hidden md:block" data-id="element-265">
            +
          </div>
          <div className="bg-white rounded-2xl p-8 shadow-soft border border-brand-light w-full md:w-64" data-id="element-266">
            <Gift className="w-12 h-12 text-brand-accent mx-auto mb-4" data-id="element-267" />
            <div className="text-4xl font-extrabold text-brand-navy mb-2" data-id="element-268">
              4
            </div>
            <div className="text-brand-navy/70 font-medium" data-id="element-269">
              Bonos de Acción
            </div>
          </div>
          <div className="text-brand-accent font-bold text-3xl hidden md:block" data-id="element-270">
            =
          </div>
          <div className="bg-brand-accent rounded-2xl p-8 shadow-soft-lg text-white w-full md:w-64" data-id="element-271">
            <FileText className="w-12 h-12 text-white mx-auto mb-4" data-id="element-272" />
            <div className="text-4xl font-extrabold mb-2" data-id="element-273">+40</div>
            <div className="text-white/90 font-medium" data-id="element-274">Recursos Listos</div>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-6" data-id="element-275">
          {[Target, MessageSquare, Users, Bot, Calendar].map((Icon, i) => <div key={i} className="w-16 h-16 rounded-full bg-white shadow-soft flex items-center justify-center text-brand-accent" data-id="element-276">
              <Icon className="w-8 h-8" data-id="element-277" />
            </div>)}
        </div>
      </div>
    </section>;
}